export const text = {
    images: 'https://phongtro123.com/images/support-bg.jpg',
    content: 'Liên hệ với chúng tôi nếu bạn cần hỗ trợ:',
    contacts: [
        {
            text: 'Hỗ trợ đăng tin',
            phone: '0901424123',
            zalo: '0901424123'
        },
        {
            text: 'Hỗ trợ thanh toán',
            phone: '0901424123',
            zalo: '0901424123'
        },
        {
            text: 'Phản ánh/khiếu nại',
            phone: '0901424123',
            zalo: '0901424123'
        },
    ]
}